const getAwardDisplayName = (
  locale: string,
  awardDisplayNames?: Record<string, string>
): string | undefined => {
  if (!awardDisplayNames) {
    return undefined;
  }

  const localeKey = `LOCALE_${locale.toUpperCase()}`;
  const englishLocaleKey = 'LOCALE_EN';

  return awardDisplayNames[localeKey] || awardDisplayNames[englishLocaleKey];
};

export default getAwardDisplayName;
